module.exports = __webpack_public_path__ + "b10b3697fea64cdbfdc35a701c70414d.pdf";